import type { FC } from 'react'

import Image from 'next/image'
import { cn } from '@/lib/utils'

interface WordmarkProps {
    className?: string
}

// The round La Douceur logo, followed by the name set in the serif.
export const Wordmark: FC<WordmarkProps> = ({ className }) => (
    <span lang='fr' dir='ltr' className={cn('inline-flex items-center gap-3 font-heading text-[1.5rem] leading-none font-medium tracking-[0.14em] whitespace-nowrap', className)}>
        <Image
            src='/logo.png'
            alt=''
            width={48}
            height={48}
            className='size-[1.9em] shrink-0 scale-[1.18] rounded-full'
        />
        La Douceur
    </span>
)
